/* catalogMirror — dealer/tenant-safe handling of the localStorage catalog mirror the
 * configurator engine reads on boot (`lhc-catalog-v1`).
 *
 * The engine reads a FIXED key, so the risk is staleness: if dealer A's catalog stays in
 * localStorage and dealer B opens the configurator (or a fetch fails), the engine could
 * load the wrong tenant's prices/models. We tag the mirror with its owner and refuse to
 * trust a mirror that doesn't belong to the current tenant; we clear it on login/logout.
 */
export const CATALOG_MIRROR_KEY = "lhc-catalog-v1";
export const CATALOG_OWNER_KEY = "lhc-catalog-owner";

/** Stable per-tenant owner key for the current user (dealer-scoped catalogs). */
export function ownerKeyFor(user) {
  if (!user) return "anon";
  if (user.dealer_id) return `dealer:${user.dealer_id}`;
  if (user.manufacturer_id) return `mfr:${user.manufacturer_id}`;
  if (user.role === "SUPERADMIN" || user.role === "ADMIN") return "platform";
  return user.id ? `user:${user.id}` : "anon";
}

export function writeCatalogMirror(blob, owner) {
  try {
    localStorage.setItem(CATALOG_MIRROR_KEY, JSON.stringify({ ...(blob || {}), _v: 2 }));
    localStorage.setItem(CATALOG_OWNER_KEY, owner || "");
    return true;
  } catch (_) { return false; }
}

export function mirrorOwner() {
  try { return localStorage.getItem(CATALOG_OWNER_KEY); } catch (_) { return null; }
}

export function clearCatalogMirror() {
  try {
    localStorage.removeItem(CATALOG_MIRROR_KEY);
    localStorage.removeItem(CATALOG_OWNER_KEY);
  } catch (_) { /* ignore */ }
}

/** Remove the mirror if it belongs to a different tenant than `owner` (stale leak guard). */
export function clearMirrorIfStale(owner) {
  const cur = mirrorOwner();
  if (cur != null && cur !== owner) { clearCatalogMirror(); return true; }
  return false;
}
